export const DEBUG = 'debug';
export const START_SCREEN = 'start_screen';
export const MAIN = 'main';
export const LOADING = 'loading';
export const LEFT_HANDED_CONTROLS = 'left_handed_controls';
export const RIGHT_HANDED_CONTROLS = 'right_handed_controls';
export const LEFT_RIGHT_CONTROLS = 'left_right_controls';
export const BASE_CONTROLS = 'base_controls';
export const KEYBOARD_CONTROLS = 'keyboard_controls';
export const SCORE = 'score';
export const COUNT_DOWN = 'count_down';
export const COMPLETE = 'complete';
export const PLAYERS = 'players';
export const PLAYER = 'player';
export const CHALLENGERS = 'challengers';
export const END_SCORE = 'end_score';
export const LEADERBOARDS = 'leaderboards';
export const LEADERBOARD = 'leaderboard';
export const PAUSED = 'paused';
export const CONTINUE = 'continue';
export const INTERSTITIAL = 'interstitial';
export const CONTROLS_TUTORIAL = 'controls_tutorial';
export const FEATURE_NOT_AVAILABLE = 'feature_not_available';